var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.proposals.length || _vm.agreements.length
    ? _c(
        "action-card",
        {
          attrs: {
            title: _vm.$t("nav.agreements"),
            icon: "handshake",
            count: _vm.proposals.length + _vm.agreements.length
          },
          on: {
            open: function($event) {
              return _vm.$router.push("/agreements")
            }
          }
        },
        [
          _vm._l(_vm.visibleProposals, function(proposal) {
            return _c(
              "button",
              {
                key: "proposal-" + proposal.id,
                staticClass: "portal-action-row",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.openProposal(proposal)
                  }
                }
              },
              [
                _c("span", { staticClass: "action-row-copy" }, [
                  _c("strong", {
                    domProps: { innerHTML: _vm._s(_vm.safeHeading(proposal)) }
                  }),
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.$t("global.submitted")) +
                        " " +
                        _vm._s(
                          _vm.DateTime.fromISO(proposal.dateSent).toFormat(
                            "MMM dd"
                          )
                        )
                    )
                  ])
                ]),
                _c("portal-icon", {
                  attrs: { name: "chevron-right", size: 18 }
                })
              ],
              1
            )
          }),
          _vm._l(_vm.visibleAgreements, function(agreement) {
            return _c(
              "button",
              {
                key: "agreement-" + agreement.id,
                staticClass: "portal-action-row",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.openAgreement(agreement)
                  }
                }
              },
              [
                _c("span", { staticClass: "action-row-copy" }, [
                  _c("strong", [_vm._v(_vm._s(agreement.name))]),
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.$t("global.submitted")) +
                        " " +
                        _vm._s(
                          _vm.DateTime.fromISO(agreement.dateCreated).toFormat(
                            "MMM dd"
                          )
                        )
                    )
                  ])
                ]),
                _c("portal-icon", {
                  attrs: { name: "chevron-right", size: 18 }
                })
              ],
              1
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }